import { Section } from "../../../components/Section";
import { FormField, TextInput } from "../../../components/ui/FormComponents";
import { ContactDetails } from "../../../types/mortgage";
import { validateEmail, validateTelephone, getValidationMessage } from "../../../utils/validationUtils";

interface ContactDetailsSectionProps {
  data: ContactDetails;
  onChange: (data: ContactDetails) => void;
  showValidation: boolean;
  readonlyFields?: {
    name?: boolean;
    email?: boolean;
    telephone?: boolean;
  };
}

export function ContactDetailsSection({ 
  data, 
  onChange, 
  showValidation, 
  readonlyFields = {}
}: ContactDetailsSectionProps) {
  const updateField = <K extends keyof ContactDetails>(field: K, value: ContactDetails[K]) => {
    onChange({ ...data, [field]: value });
  };

  const emailError = showValidation && data.email && !validateEmail(data.email) 
    ? getValidationMessage("email", "invalid")
    : undefined;

  const telephoneError = showValidation && data.telephone && !validateTelephone(data.telephone) 
    ? getValidationMessage("telephone", "invalid")
    : undefined;

  return (
    <Section title="Contact Details" colorTheme={1}>
      <div className="space-y-4">
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-md p-3">
          <p className="text-sm text-blue-800 dark:text-blue-300">
              If you would like to be contacted by one of our BDMs, please provide your contact information below. The information will only be used for this purpose and is processed in line with our Privacy Policy.
              </p>
            <p className="text-sm text-blue-800 dark:text-blue-300">
              Should you prefer not to be contacted, please leave these field blank – you can still use the calculator.
          </p>
        </div>

        <div className="space-y-4">
          <FormField 
            label="Name" 
            required={false}
            helpText={readonlyFields.name ? "Name from your profile" : undefined}
          >
            <TextInput
              type="text"
              value={data.name || ""}
              onChange={(value) => updateField("name", value)}
              placeholder="Your full name"
              readOnly={readonlyFields.name}
            />
          </FormField>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <FormField 
            label="Email address" 
            required={false}
            error={emailError}
            helpText={readonlyFields.email ? "Email from your profile" : undefined}
          >
            <TextInput
              type="email"
              value={data.email || ""}
              onChange={(value) => updateField("email", value)}
              placeholder="your.email@example.com"
              readOnly={readonlyFields.email}
              error={!!emailError}
            />
          </FormField>

          <FormField 
            label="Telephone number" 
            required={false}
            error={telephoneError}
            helpText={readonlyFields.telephone ? "Phone from your profile" : undefined}
          >
            <TextInput
              type="tel"
              value={data.telephone || ""}
              onChange={(value) => updateField("telephone", value)}
              placeholder="+44 123 456 7890"
              readOnly={readonlyFields.telephone}
              error={!!telephoneError}
            />
          </FormField>
          </div>
        </div>
      </div>
    </Section>
  );
}
